
const calculateBearing = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
  const y = Math.sin(lng2 - lng1) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1);
  return ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360;
};


export const getStreetViewUrlFromCoords = async (lat: number, lng: number, apiKey: string): Promise<string | null> => {
  try {
    // Get Street View metadata with larger radius
    console.log('getting street view url from coords', lat, lng);
    const metadataUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&radius=50&key=${apiKey}`;
    const metadataRes = await fetch(metadataUrl);
    const metadataData = await metadataRes.json();
    
    if (metadataData.status !== "OK") {
      // If metadata fails, try direct streetview call with coordinates
      return `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${lat},${lng}&key=${apiKey}`;
    }
    
    const { lat: panoLat, lng: panoLng } = metadataData.location;
    const heading = calculateBearing(panoLat, panoLng, lat, lng);
    
    // Return Street View image URL
    return `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${panoLat},${panoLng}&heading=${heading.toFixed(2)}&pitch=0&fov=90&key=${apiKey}`;
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

export const getStreetViewUrlFromAddress = async (address: string, lat: number, lon: number, apiKey: string): Promise<string | null> => {
  try {
    // Direct Street View call with address, same as working example
    return `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${encodeURIComponent(address)}&key=${apiKey}`;
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

export const getStreetViewUrlsFromCoords = async (lat: number, lng: number, apiKey: string): Promise<string[] | null> => {
  try {
    // Get Street View metadata with larger radius
    console.log('getting street view urls from coords', lat, lng);
    const metadataUrl = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&radius=50&key=${apiKey}`;
    const metadataRes = await fetch(metadataUrl);
    const metadataData = await metadataRes.json();
    
    let panoLat = lat;
    let panoLng = lng;
    
    if (metadataData.status === "OK" && metadataData.location) {
      panoLat = metadataData.location.lat;
      panoLng = metadataData.location.lng;
    }
    // If metadata fails, we'll use the provided coordinates directly
    
    // Return four Street View image URLs with different angles (0, 90, 180, 270 degrees)
    const angles = [0, 90, 180, 270];
    return angles.map(angle => 
      `https://maps.googleapis.com/maps/api/streetview?size=800x400&location=${panoLat},${panoLng}&heading=${angle}&pitch=0&fov=90&key=${apiKey}`
    );
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

export const getStreetViewUrlsFromAddress = async (address: string, lat: number, lon: number, apiKey: string): Promise<string[] | null> => {
  try {
    // Direct Street View call with address, same as working example
    // Return four Street View image URLs with different angles (0, 90, 180, 270 degrees)
    const angles = [0, 90, 180, 270];
    return angles.map(angle => 
      `https://maps.googleapis.com/maps/api/streetview?size=800x400&source=outdoor&heading=${angle}&location=${encodeURIComponent(address)}&pitch=0&fov=90&key=${apiKey}`
    );
  } catch (error) {
    console.error('Street View error:', error);
    return null;
  }
};

